<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">No class selected.</b-alert>

          <div v-if="!error && !loading">
            <div v-if="showVideo">
              <b-embed v-if="showVideo" ref="plyr"
                type="iframe"
                aspect="16by9"
                :src="getVideoUrl"
                allowfullscreen
              ></b-embed>
            </div>

            <div>  <!-- button row  tutorial / ondemand / archive -->
              <b-row v-if="classObj.isTutorial">  <!-- tutorial video/pdf -->
                <b-col class="mt-3 mb-3 text-center">
                  <b-overlay :show="logging" rounded="sm">
                    <b-button v-if="isVideo" @click="toggleVideo">{{btnViewLabel}}</b-button>
                    <b-button v-if="isPDF" @click="viewPDF">{{btnViewLabel}}</b-button>
                  </b-overlay>
                </b-col>
              </b-row>
              <b-row v-if="!classObj.isTutorial">  <!-- ondemand video/pdf/archive/flash(stubbed) -->
                <b-col class="mt-3 mb-3 text-center">
                    <div class="mb-2">
                      <b-overlay :show="logging" rounded="sm">
                        <b-button v-if="isVideo" @click="toggleVideo" class="mr-2">{{btnViewLabel}}</b-button>
                        <b-button v-if="isPDF" @click="viewPDF" class="mr-2">View PDF</b-button>
                        <b-button v-if="isArchive" :disabled="true" @click="toggleVideo" class="mr-2">{{btnViewLabel}}</b-button>
                        <!-- Exam button -->
                        <b-button v-if="!studentData.examTaken" :disabled="btnTakeExamDisabled" @click.prevent="gotoExam" class="ml-2">Take Exam</b-button>
                      </b-overlay>
                    </div>
                    <b-button-group v-if="debug">  <!-- debug only -->
                      <b-button size="sm" variant="success" :to="{ path: `/eval/${classHash}`}">Eval</b-button>
                      <b-button size="sm" variant="info" :to="{ path: `/sva/${classHash}` }">SVA</b-button>
                      <b-button size="sm" variant="secondary" :to="{ path: `/survey/${classHash}` }">Survey</b-button>
                      <b-button size="sm" variant="warning" :to="{ path: `/exam/${classHash}` }">Exam</b-button>
                    </b-button-group>
                </b-col>
              </b-row>
            </div>

            <div v-if="!classObj.isTutorial">  <!-- alert banners -->
              <b-alert :show="isArchive" variant="warning"><b>Video Upcoming</b> The on-demand video of this live webinar is being produced.<br>Please check back.</b-alert>
              <b-alert :show="isFlash" variant="danger"><b>Video Unavailable</b> The video for this class is not available on this device.</b-alert>
              <b-alert :show="!classObj.canShowExam" variant="warning"><b>Exam Upcoming</b> After the webinar, you will be emailed a link to your CE exam.<br>Please allow up to two hours to receive your email.</b-alert>
              <b-alert :show="studentData.status && !studentData.examTaken && !hasExamsLeftToday" variant="danger"><b>Exam Limit Reached:</b> You’ve reached the limit of 10 exams per day.  Please resume your self-study activity another day.</b-alert>
              <b-alert :show="studentData.examTaken" variant="info">
                <b>Exam Completed</b> on {{studentData.examDate}} with a score of {{studentData.examScore}}.
                Credits: {{studentData.credits}}&nbsp;{{ studentData.ceTypeId | prettyCEType }}
                <certbutton :c="buildClass()" :s="buildStudentData()"></certbutton>
              </b-alert>
            </div>

            <div class="div-section-body" style="padding: 0 2px 0 3px;">
              <div style="padding: 5px 5px 10px 3px;">
                <b-row style="padding: 5px 5px 10px 3px;">
                  <b-col cols="4">
                    <div class="text-center">
                      <b-img fluid v-bind:src="classObj.photo" />
                      <div v-if="studentData.examTaken" class="text-center completed">COMPLETED</div>
                      <queuebutton :c="classObj.hash" :s="studentHash" :q="studentData.inqueue"></queuebutton>
                    </div>
                  </b-col>
                  <b-col cols="8" style="margin-left: -20px;">
                    <div class="class-title">{{classObj.className}}</div>
                    <div class="class-details">
                      <div v-if="!classObj.isTutorial && classObj.name">
                        {{classObj.name}}
                        <br />
                      </div>
                      <span v-text="(classObj.isTutorial) ? 'Company' : 'Sponsor'"></span>: {{classObj.companyName}}
                      <br />
                      {{classObj.releaseDate | prettyDate}}<span v-if="!classObj.isTutorial"> - {{classObj.credits}} CEU (Self Study)</span>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <!-- :inner-html.prop instead of v-html -->
                  <b-col class="mt-2 txt-class-blurb" :inner-html.prop="this.classObj.description | nl2br"></b-col>
                </b-row>
              </div>
            </div>

          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"
import constants from "@/config/constants"

var data = {
  debug: false,
  error: false,
  loading: true,
  msg: "Classroom",
  blurb: "Classroom blurb.",
  classObj: {},
  studentData: {status: false,  ceTypeId: 1, examTaken: false, examsLeftToday: 10},
  studentHash: '',
  classHash: '',
  showVideo: false,
  logging: false
}

export default {
  name: "Classroom",
  data() {
    return data;
  },
  props: {
    // route set to use props mapped to url parameters
    c: {
      type: String,
      required: true,
      default: ""
    }
  },
  computed: {
    isVideo() {
      let aout = this.classObj.typeId != constants.CLASS_TYPE.ARCHIVE
            && this.classObj.typeId != constants.CLASS_TYPE.PDF
            && this.classObj.youtubeUrl != null;
      // console.log(`isVideo: ${aout}`)
      return aout
    },
    isPDF() {
      let aout = this.classObj.typeId === constants.CLASS_TYPE.PDF
            && this.classObj.pdfClassFile !== null;
      // console.log(`isPDF: ${aout}`)
      return aout
    },
    isArchive() {
      let aout =  this.classObj.typeId === constants.CLASS_TYPE.ARCHIVE
      // console.log(`isArchive: ${aout}`)
      return aout
    },
    isLive: function() {
      // Indicates student started live webinar.
      return this.studentData.studentStarted
    },
    isFlash() {
      let aout = this.classObj.typeId != constants.CLASS_TYPE.ARCHIVE
            && this.classObj.typeId != constants.CLASS_TYPE.PDF
            && this.classObj.youtubeUrl == null;
      // console.log(`isFlash: ${aout}`)
      return aout
    },
    hasVideo() {
      let aout = this.classObj.youtubeUrl != null
      // console.log(`hasVideo: ${aout}`)
      return aout
    },
    getVideoUrl() {
      let code = utils.getYoutubeCode(this.classObj.youtubeUrl)
      let url = utils.getYoutubeUrl(code, true)
      return url
      // return 'https://www.youtube.com/embed/zpOULjyy-n8?rel=0'  // reo
      // return 'https://www.youtube.com/embed/pTvxZgiuU3Y?rel=0'
      // return 'https://www.youtube.com/watch?v=pTvxZgiuU3Y&rel=0'  // viva
    },
    btnViewLabel() {
      let txt = ''
      if (this.showVideo) {
        txt = (this.classObj.isTutorial) ? 'Hide Tutorial' : 'Hide Class'
      }
      else {
        txt = (this.classObj.isTutorial) ? 'View Tutorial' : 'View Class'
      }
      return txt
    },
    hasExamsLeftToday() {
      // Returns true if:
      // -- live class
      // -- OnDemand class and studentData.examsLeftToday > 0
      return (this.isLive || (this.studentData.examsLeftToday > 0))
    },
    btnTakeExamDisabled() {
      // Return true if exam button should be disabled.
      // Reasons for disabled:
      // -- classObj.canShowExam is false
      if (this.debug) console.log(`canShowExam: ${this.classObj.canShowExam}  isLive: ${this.isLive}  hasExamsLeftToday: {this.hasExamsLeftToday}`)
      // return (!this.classObj.canShowExam || (!this.isLive && !this.hasExamsLeftToday))
      return (!this.classObj.canShowExam || !this.hasExamsLeftToday)
    },
    btnExamVariant() {
      return (this.classObj.zoomCode !== null) ? 'secondary' : 'secondary'
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    gotoExam() {
      // Exam flow: affidavit -> eval -> sva/survey -> exam.
      // Student will not have gradebook record until they:
      // 1) start ondemand webinar
      // 2) start live webinar
      this.$router.push({ path: `/affidavit/${this.classHash}` })
    },
    buildClass() {
      let aout = {
        status: true,
        classId: this.classObj.classId,
        agdCode: this.classObj.agdCode,
        agdCategory: this.classObj.agdCategory,
        className: this.classObj.className,
        speakerName: this.classObj.name,
        classHash: this.classObj.hash,
        description: this.classObj.description,
        podcastHash: null
      }
      return aout
    },
    buildStudentData() {
      let aout = {
        status: true,
        hash: this.studentHash,
        name: this.$root.getStudentName(),
        examDate: this.studentData.examDate,
        credits: this.studentData.credits,
        ceTypeId: this.studentData.ceTypeId
      }
      return aout
    },
    toggleVideo() {
      // console.log(`toggleVideo: ${this.classHash}`)
      if (this.showVideo) {
        this.showVideo = false
      }
      else {
        this.logging = true
        service
          .classView(this.classHash, this.studentHash)
          .then(
            (res => {
              if (this.debug) console.log(res)
              if (res.status) {
                  this.studentData.status = res.status
                  this.studentData.gradebookId = res.gradebookId
                  this.showVideo = true
              }
              else {
                this.error = true
              }
            }).bind(this)
          )
          .finally(e => {
            this.logging = false
          })
          .catch(e => {
            this.error = true
            console.log(e);
          })
      }
    },
    viewPDF() {
      // console.log(`toggleVideo: ${this.classHash}`)
      this.logging = true
      service
        .classView(this.classHash, this.studentHash)
        .then(
          (res => {
            if (this.debug) console.log(res)
            if (res.status) {
                this.studentData.status = res.status
                this.studentData.gradebookId = res.gradebookId
            }
            else {
              this.error = true
            }
          }).bind(this)
        )
        .finally(e => {
          this.logging = false
          // this.$router.push(this.classObj.pdfClassUrl)
          // console.log(`open: ${this.classObj.pdfClassFile}`)
          let win = window.open(this.classObj.pdfClassFile, '_blank')
          if (win) win.focus()
        })
        .catch(e => {
          this.error = true
          console.log(e);
        })
    }
  },
  created() {
    this.classHash = this.c || this.$route.query.c || this.$root.getClassHash() || "";
    this.studentHash = this.$root.getToken();
    if (this.classHash) {
      service
        .getClass(this.classHash, this.studentHash)
        .then(
          (data => {
            if (this.debug) console.log(data);
            if (data.status) {
              this.classObj = data.classObj
              if (data.studentData.status) {
                this.studentData = data.studentData
                if (this.debug) console.log(`Exams Left Today: ${this.studentData.examsLeftToday}`)
              }
            }
            else {
              this.error = true
            }
          }).bind(this)
        )
        .finally(e => {
          this.loading = false;
          // console.log(`finally...`);
        })
        .catch(e => {
          this.error = true;
          console.log(e);
        });
    } else {
      this.$router.push("exams");
    }
    // this.error = this.$root.getClassId() === 0;
  },
  mounted () { },
  beforeDestroy() {
    // console.log('beforeDestroy')
    this.classObj = {status: false}
    this.studentData = {status: false,  ceTypeId: 1, examTaken: false, examsLeftToday: 10}
    this.showVideo = false
    this.loading = true
    this.logging = false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Classroom.vue